module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step2_Image19b.50343886.jpg";